<app-efa-org-card
  [previous]="previous"
  [i18nRoot]="viewType"
  [showHint]="showHint"
  [cxFocus]="{ autofocus: true }"
  >
  <ng-content select="[actions]" ngProjectAs="[actions]"></ng-content>
  <ng-content select="[main]" ngProjectAs="[main]"></ng-content>
  <ng-content select="[info]" ngProjectAs="[info]"></ng-content>

  @if (dataStructure$ | async; as structure) {
    <ng-container main>
      @if (listData$ | async; as data) {
        <section>
          @if (data.values?.length > 0) {
            <cx-table
              [structure]="structure"
              [data]="data.values"
              [i18nRoot]="domainType"
              [currentItem]="{ property: key, value: subKey$ | async }"
              >
            </cx-table>
          } @else {
            <p class="is-empty">{{ 'organization.messages.emptyList' | cxTranslate }}</p>
          }
        </section>
        @if (data.pagination?.totalPages > 1) {
          <div class="footer">
            <cx-pagination
              [pagination]="data.pagination"
              (viewPageEvent)="browse(data.pagination, $event)"
            ></cx-pagination>
          </div>
        }
      }
    </ng-container>
  }
</app-efa-org-card>

